import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { environment } from '@sbd-doug-frontend/app/environments/environment';

export interface QuoteRequestTaskAssociation {
  uri?: string;
  result_uri?: string;
  order_number?: string;
  bond_label?: string;
  client_name?: string;
  principal_name?: string;
  client_phone?: string;
  client_email?: string;
  quote_request_id?: number;
  quote_request_access_url?:string
}

@Component({
  selector: 'app-quote-request-task-association-view',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltip,
  ],
  templateUrl: './quote-request-task-association-view.component.html',
})
export class QuoteRequestTaskAssociationViewComponent {
  @Output() disassociateQuoteRequestEvent = new EventEmitter<void>();
  @Input() quoteRequestTaskAssociation!: QuoteRequestTaskAssociation;

  onDetachQuoteRequestEvent() {
    this.disassociateQuoteRequestEvent.emit();
  }

  formatUri() {

    if(this.quoteRequestTaskAssociation?.quote_request_access_url){
      return this.quoteRequestTaskAssociation?.quote_request_access_url;
    }

    if(this.quoteRequestTaskAssociation?.result_uri){
      return environment.dougV2BaseUrl + this.quoteRequestTaskAssociation?.result_uri;
    }

    return environment.dougV2BaseUrl + this.quoteRequestTaskAssociation?.uri;
  }

  get url(): string {
    return this.formatUri();
  }
}
